import CXMApiClient from "../CXMApiClient";
function initialState() {
  return {
    SalesTaskListFields: [
      {
        id: "contactId",
        category: "customer",
        displayName: "Contact ID",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true,
        isHidden: true
      },
      {
        id: "accountPlatformId",
        category: "customer",
        displayName: "Platform ID",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true,
        isHidden: true
      },
      {
        id: "isMarkedHot",
        category: "customer",
        displayName: "Hot",
        dataType: "hotStatus",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "fullName",
        category: "customer",
        displayName: "Full Name",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true,
        IsClickable: true
      },
      {
        id: "score",
        category: "customer",
        displayName: "Score",
        dataType: "score",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "taskName",
        category: "task",
        displayName: "Task",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "taskDescription",
        category: "task",
        displayName: "Description",
        dataType: "string",
        isRequired: true,
        isSearchable: false,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: false,
        isHidden: true
      },
      {
        id: "workflowCategory",
        category: "task",
        displayName: "Category",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "taskType",
        category: "task",
        displayName: "Type",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "taskStatus",
        category: "task",
        displayName: "Status",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "futureAppointmentDate",
        category: "appointment",
        displayName: "Scheduled Appt",
        dataType: "datetime",
        isRequired: true,
        isSearchable: false,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "taskDueDt",
        category: "task",
        displayName: "Due Date",
        dataType: "datetime",
        isRequired: true,
        isSearchable: false,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "taskOwner",
        category: "customerAssignment",
        displayName: "Owner",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "salesperson1UserId",
        category: "customerAssignment",
        displayName: "SP1",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "bdcUserId",
        category: "customerAssignment",
        displayName: "BDC",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "targetedVehicle",
        category: "vehicle",
        displayName: "Targeted Vehicle",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "dealerCode",
        category: "customer",
        displayName: "Dealer",
        dataType: "string",
        isRequired: true,
        isSearchable: true,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "lastUserActivity",
        category: "recentActivity",
        displayName: "Last User Activity",
        dataType: "string",
        isRequired: true,
        isSearchable: false,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "lastCustomerActivity",
        category: "recentActivity",
        displayName: "Last Customer Activity",
        dataType: "string",
        isRequired: true,
        isSearchable: false,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: true
      },
      {
        id: "lastUserActivityDate",
        category: "recentActivity",
        displayName: "User Activity Date",
        dataType: "string",
        isRequired: true,
        isSearchable: false,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: false,
        isHidden: true
      },
      {
        id: "lastCustomerActivityDate",
        category: "recentActivity",
        displayName: "Customer Activity Date",
        dataType: "string",
        isRequired: true,
        isSearchable: false,
        searchType: null,
        searchObject: null,
        searchField: null,
        searchValueMin: null,
        searchValueMax: null,
        isSortable: false,
        isHidden: true
      }
    ]
  };
}

const state = initialState();

const getters = {
  SalesTaskListFields: function() {
    return state.SalesTaskListFields;
  }
};

const actions = {
  getTaskListCSV: async function(context, request) {
    let client = new CXMApiClient();
    let filter;

    let response = await client.ProcessRequest(
      "post",
      "/api/Lead/task/search/export",
      request
    );
    if (response && response.data && response.data.successful) {
      return response.data;
    }
    return null;
  },
  getTaskList: async function(context, request) {
    let client = new CXMApiClient();
    let filter;

    let response = await client.ProcessRequest(
      "post",
      "/api/Lead/task/search/detail",
      request
    );
    if (response && response.data && response.data.successful) {
      return response.data;
    }
    return null;
  },
  getTaskCount: async function(context, request) {
    let client = new CXMApiClient();
    let filter;

    let response = await client.ProcessRequest(
      "post",
      "/api/Lead/task/search/count",
      request
    );
    if (
      response &&
      response.data &&
      response.data.successful &&
      response.data.data
    ) {
      return response.data.data;
    }
    return null;
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/TaskList.js